<div class="form" [formGroup]="form()">
  <fu-simple-input
    [useOutlineLabel]="false"
    formControlName="email"
    [errorDictionary]="emailErrors"
    [isHintVisible]="true"
    [label]="'withdrawal.paypal.email.label' | translate"
    [placeholder]="'withdrawal.paypal.email.placeholder' | translate"
  />
</div>
